import React from 'react';
import PropTypes from 'prop-types';

export default function ProblemIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148010' />
      <g fill={fill} data-name='Grupo 151571'>
        <path
          d='M1.727 18.001h16.558a.717.717 0 0 0 .624-.363.739.739 0 0 0 0-.727L10.63 2.364a.322.322 0 0 0-.024-.034.7.7 0 0 0-.045-.064c-.017-.019-.032-.035-.05-.053a.441.441 0 0 0-.05-.046.8.8 0 0 0-.064-.048.266.266 0 0 0-.033-.024.194.194 0 0 1-.02-.01c-.024-.013-.05-.024-.073-.034s-.039-.016-.059-.022-.048-.011-.072-.016a.48.48 0 0 0-.066-.011.561.561 0 0 0-.074 0h-.064a.625.625 0 0 0-.074.013c-.02 0-.043.008-.063.014a.64.64 0 0 0-.066.026c-.021.01-.046.019-.066.03l-.022.01c-.013.008-.023.018-.035.026l-.061.045a.447.447 0 0 0-.052.05.4.4 0 0 0-.046.051.739.739 0 0 0-.046.066c-.007.011-.017.021-.024.034L1.102 16.914a.737.737 0 0 0 0 .727.728.728 0 0 0 .625.36Zm8.278-13.815 7.036 12.36H2.97Z'
          data-name='Caminho 12458'
        />
        <path d='M11 8H9v5h2Zm0 6H9v2h2Z' />
      </g>
    </svg>
  );
}

ProblemIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

ProblemIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
